module.exports = __webpack_public_path__ + "static/img/Group.de4f215.png";